<template>
    <div class="event-speakers page">
        <v-skeleton-loader
			style="max-width: 600px;"
			v-bind="attrs"
			type="card"
			v-if="this.isLoading"
		>
		</v-skeleton-loader>
        <div v-else>
            <ButtonBack />
            <div class="event-speakers__search">
                <input 
                    v-model="filters.search"
                    class="event-speakers__search-input"
                    type="text"
                    placeholder="Search"
                    @input="filterSearch"
                />
                <Icon 
                    type="search"
                    :size="26"
                    color="#8E8E93"
                />
            </div>
            <NewsFeedEmpty
                v-if="!eventSpeakers.length"
				title="No speakers found."
				description="Check back later or use search."
			/>
            <div v-else>
                <h2 class="event-speakers__title">
                    Speakers
                </h2>
                <EventSpeakerCard 
                    v-for="speaker in eventSpeakers"
                    :key="speaker.speaker_id"
                    :speaker="speaker"
                />
            </div>
    
            <div class='d-flex my-9 justify-center event-speakers__pagination' v-if='!isLoading && eventSpeakers.length > 0'>
                <Pagination 
                    :page="filters.page"
                    :pageCount="+this.eventSpeakersMeta.pageCount"
                    v-on:pageChange="onPageChange"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ButtonBack from '@/components/ButtonBack'
import Pagination from '@/components/Pagination'
import EventSpeakerCard from '@/components/Event/EventSpeakerCard'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import { mapActions, mapGetters } from 'vuex';

const DEBOUNCE_TIMEOUT = 500

export default {
    components: {
        ButtonBack,
        Pagination,
        EventSpeakerCard,
        NewsFeedEmpty
    },
    data() {
        return {
            filters: {
                search: '',
                page: 1
            },
            attrs: {
                class: 'mb-6',
                elevation: 0,
            },
            timer: 0
        }
    },
    methods: {
        ...mapActions('event', ['getEventSpeakersById', 'clearEventSpeakers']),

        getSpeakers(page) {
            let query = `event_id=${+this.$route.params.id}&page=${page}`
            if (this.filters.search.length) {
                query += `&search=${this.filters.search}`
            } 
            this.getEventSpeakersById(query)
        },
        onPageChange(page) {
            if (this.filters.page !== page) {
                this.getSpeakers(page)
            }
        },
        filterSearch(e) {
            clearTimeout(this.timer)
            this.filters.page = 1

            this.timer = setTimeout(() => {
                this.getSpeakers(1)
            }, DEBOUNCE_TIMEOUT)
        },
    },
    computed: {
        ...mapGetters('event', ['eventSpeakers', 'eventSpeakersMeta', 'isLoading'])
    },
    created() {
        this.getSpeakers(this.filters.page)
    },
    beforeDestroy() {
        this.clearEventSpeakers()
    }
}
</script>
<style lang="scss">
.event-speakers {
    font-family: Montserrat, sans-serif;

    &__title {
        font-size: 24px;
        font-weight: 700;
        color: #4A4A4A;
        line-height: 29.26px;
        margin-bottom: 30px;
    }

    &__search {
        display: flex;
        flex-wrap: nowrap;
        padding: 12px 14px;
        background: #fff;
        border: 1px solid #E2E2E2;
        border-radius: 10px;
        margin: 30px 0;

        &-input {
            flex-grow: 1;
            outline: none;
            font-size: 16px;
            font-weight: 400;
            color: #697583;
            line-height: 19.5px;
        }
    }
}
</style>